// extracted by mini-css-extract-plugin
export default {"pageSpin":"ElectricMapConfig_pageSpin__WIDof","sectionEditAction":"ElectricMapConfig_sectionEditAction__uptKS","sectionDivider":"ElectricMapConfig_sectionDivider__gSpsF"};